import { useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { Content, Main } from "../../../components/Layout";
import TraineeSubMenu from "../../../components/Submenu/TraineeSubMenu";
import AttendanceTable from "../../../components/AttendanceTable";
import Loading from "../../../components/Loading";

export default function TraineesAttendance() {
  const { trainee, setisWaitingResponse } = useOutletContext() || {};
  const { traineesId } = useParams();
  const [attendances, setattendances] = useState();

  return (
    <Row>
      <Col sm={9}>
        <Main>
          <Content>
            {!!attendances && (
              <Row>
                <Col>
                  <div className="mb-4">
                    <h2 className="mini-title">Atendimentos</h2>
                    <p className="small-label mb-2">
                      Acompanhe e gerencie os atendimentos registrados. Visualize o status de cada solicitação e
                      assegure um acompanhamento eficiente das interações com os formandos.
                    </p>
                  </div>
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <AttendanceTable
                  query={`trainee_id=${traineesId}&paginate=false`}
                  attendances={attendances}
                  setattendances={setattendances}
                  applyFilter={() => {}}
                  url_type="trainee"
                  trainee_id={traineesId}
                />
              </Col>
            </Row>
          </Content>
        </Main>
      </Col>
      <Col sm={3}>
        <TraineeSubMenu trainee={trainee} />
      </Col>
    </Row>
  );
}
